<template>
    <v-dialog v-model="dialog" persistent style="background-color: red;" max-width="600" v-resize="onResize">
        <v-card class="confirm-copy-doc-card">
            <v-row no-gutters class="standard-row font-theme d-flex justify-center header-copy-doc-modal text-center">
                ยืนยันการคัดลอกเอกสาร
            </v-row>
            <v-row no-gutters class="standard-row font-theme" style="padding-bottom: 10%;">
                <v-col cols="12" sm="6" md="6" lg="6" class="d-flex justify-end pr-sm-9 px-9 pl-sm-0">
                    <v-btn @click="confirmCopyDoc()" color="#0B68D6" height="53" :width="windowSize.x <= 600? '100%' :'150'" class="white--text button-copy-doc-modal">
                        ยืนยัน
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="pl-sm-9 px-9 pl-sm-0 pt-6 pt-sm-0">
                    <v-btn @click="dialog = false" color="#F5F5F5" height="53" :width="windowSize.x <= 600? '100%' :'150'" class="button-copy-doc-modal" style="border: 1px solid #000000;">
                        ยกเลิก
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
    export default {
        data: () => ({
            dialog: false,
            documentId: null,
            windowSize: { x: 0 },
        }),
        mounted () {
            EventBus.$on('confirmCopyDoc', this.openModal)
        },
        beforeDestroy () {
            EventBus.$off('confirmCopyDoc')
        },
        methods: {
            openModal(id) {
                this.documentId = id
                this.dialog     = true
            },
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            confirmCopyDoc() {
                this.$store.commit('setIsCopyDoc', true)
                this.$store.commit('setTransactionId', this.documentId)
                this.$router.push({ path: '/inbox/purchase_detail'})
            }
        }
    }
</script>

<style>
    .confirm-copy-doc-card {
        border-radius: 20px !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25);
        background-color: #F4F4F4 !important;
    }

    .header-copy-doc-modal {
        font-size: 32px;
        font-weight: 700;
        padding-top: 14.6%;
        padding-bottom: 10%;
    }

    .button-copy-doc-modal {
        border-radius: 20px;
        font-size: 20px !important;
        font-weight: 700;
        box-shadow: none;
    }
</style>